<template>
  <b-badge 
    :variant="variant" 
    pill
  >
    {{ certificaatStatus }} {{ geldigheidsduur }}
  </b-badge>
</template>
<script>
import { keuringMixin } from "@/mixins/keuringMixin";

export default {
    name: 'KeuringsStatus',
    components: {

    },
    mixins: [
        keuringMixin
    ],
    props: {
        status: {
            type: Number,
            default: -1
        },
        deadline: {
            type: Date,
            default: null
        }
    },
    data() {
        return  {
            
        }
    },
    computed: {
        certificaatStatus: function() {
            var result = this.keuringstatus.find( ({ value }) => value === this.actueleKeuringsstatus );
            return result ? result.text : 'Onbekend';
        },
        actueleKeuringsstatus() {
            if (this.status !== 1) return this.status;
            var deadline = new Date(this.deadline);
            var today = new Date();
            if (deadline < today) return -3;
            return 1;
        },
        geldigheidsduur() {
            // aantal dagen geldigheidsduur van/naar deadline
            if (this.actueleKeuringsstatus === 1 || this.actueleKeuringsstatus === -3) return this.moment(this.deadline).diff(this.moment(), 'days') + ' dgn.';
        },
        variant: function() {
            return this.keuringcolor[this.actueleKeuringsstatus + 3];
        },
    },
    watch: {},
    mounted () {
        
    },
    methods: {},
          
}
</script>